import React from 'react';
import styled from 'styled-components';
import OzeCounterProjects from './OzeCounterProjects';
import OzeRealized from './Ozerealized';
import { cms } from 'assets/cms';
import OzeInstallations from './Ozeinstallations';

const Wrapper = styled.div`
  /* background-color: pink; */
  background: rgb(9, 125, 67);
  background: linear-gradient(
    236deg,
    rgba(9, 125, 67, 1) 20%,
    rgba(0, 102, 51, 1) 62%
  );
  /* background: center center url(${cms.oze.ozeoffer}); */
  background-size: cover;
  color: white;

  @media ${({ theme }) => theme.media.mobile} {
    margin: 0 auto;
    display: flex;
    flex-direction: column;
  }
  @media ${({ theme }) => theme.media.tabet} {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
  }
`;

const OzeCounter = () => (
  <Wrapper>
    <OzeCounterProjects />
    <OzeRealized />
    <OzeInstallations />
  </Wrapper>
);

export default OzeCounter;
